import { Link, Text, TextProps } from "@jsq/ds/core";
import { getInvestingProfileName } from "../../../Profiles/utils";
import { CaseLink } from "../../styles_vanilla.css";
import { SourceCaseType } from "../../types";

type Props = {
  detail: string | number | null | undefined;
  sourceCase?: SourceCaseType;
} & TextProps;

const EscalationDetail = ({ detail, sourceCase, ...rest }: Props) => (
  <>
    <Text variant="secondary-sm" {...rest}>
      {detail + " of "}
    </Text>
    <Link
      to={sourceCase?.id ? `/compliance/case/${sourceCase?.id}` : "#"}
      className={CaseLink}
      icon="external-link"
      iconPosition="right"
    >
      {sourceCase?.name || getInvestingProfileName(sourceCase?.investingProfile)}
    </Link>
  </>
);

export default EscalationDetail;
